export default {
	'dashboard.SalesCard.today': 'Today',
	'dashboard.SalesCard.thisWeek': 'This Week',
	'dashboard.SalesCard.thisMonth': 'This Month',
	'dashboard.SalesCard.thisYear': 'This Year',
	'dashboard.SalesCard.sales': 'Sales',
	'dashboard.SalesCard.salesVolume': 'Sales Volume',
	'dashboard.SalesCard.salesRank': 'Store Sales Ranking',
	'dashboard.SalesCard.views': 'Visits',
	'dashboard.SalesCard.viewsVolume': 'Number of visits',
	'dashboard.SalesCard.viewsRank': 'Store visit ranking',
	'dashboard.SalesCard.storeNumber': 'Store No. {number}',
}
